

<p-table [value]="cars">
  <ng-template pTemplate="header">
    <tr>
      <th>Vin</th>
      <th>Year</th>
      <th>Brand</th>
      <th>Color</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-car>
    <tr>
      <td>hbh</td>
      <td>{{car.year}}</td>
      <td>{{car.brand}}</td>
      <td>{{car.color}}</td>
    </tr>
  </ng-template>
</p-table>


<p-calendar [(ngModel)]="date6" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030"></p-calendar>


<app-info-panels></app-info-panels>

<app-info-cards></app-info-cards>

<div class="row mb-2">
  <div class="col-lg-6 mb-4">
    <app-visitors></app-visitors>
  </div>
  <div class="col-lg-6 mb-4">
    <app-cost></app-cost>
  </div>
</div>

<div class="row">
  <div class="col-lg-5 mb-4">
    <app-disk-space></app-disk-space>
  </div>
  <div class="col-lg-7 mb-4">
    <app-todo></app-todo>
  </div>
</div>
